// Variant change
this.customVariantChangeEvent = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    console.info('%c[Variant changed]', 'color: #5fb8ff')
    console.log(event.data)
});

// Cart change
this.customCartChangeEvent = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    console.info('%c[Cart updated]', 'color: #5fb8ff')
    console.log(event)
});

// Cart error
this.customCartErorrEvent = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
    console.info('%c[Cart error]', 'color: #5fb8ff')
    console.log(event)
});

// Qty change
this.customQtyChangeEvent = subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
    console.info('%c[Quantity updated]', 'color: #5fb8ff')
    console.log(event.data)
});

// Options change
this.customOptionsChangeEvent = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
    console.info('%c[Options change]', 'color: #5fb8ff')
    console.log(event.data)
});